import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth, signInWithEmailAndPassword } from 'firebase/auth';
import { getPerformance } from 'firebase/performance';

const firebaseConfig = {
  apiKey: 'AIzaSyD26Slt0BmKF98F1Ik0UtKB3y6QUZ_kOnA',
  authDomain: 'blue-link-node.firebaseapp.com',
  projectId: 'blue-link-node',
  storageBucket: 'blue-link-node.firebasestorage.app',
  messagingSenderId: '1003269898160',
  appId: '1:1003269898160:web:7ac2ccdaa66ab83d2c6075',
};

// firebase.js
export const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const perf = getPerformance(app);
export const signIn = signInWithEmailAndPassword;
